import {
  M_REGULAR_COLLECTION_URLS,
  M_SEARCH_API_URL,
} from 'constants/apiConstants';
import { MSearchParam, MSearchResponse } from 'interfaces/IMasterDb';
import axiosInstance from './AxiosInstance';

export const MasterDbService = {
  FetchMRegularCollectionData: async (
    collectionKey: keyof typeof M_REGULAR_COLLECTION_URLS,
    mOrgId: string,
    pageSize: number,
    pageIndex: number
  ) => {
    const baseUrl = M_REGULAR_COLLECTION_URLS[collectionKey];
    const url = `${baseUrl}/${mOrgId}/Size/${pageSize}/Page/${pageIndex}`;
    const response = await axiosInstance.get(url);
    return response.data;
  },

  SearchMCollectionData: async <T>(
    params: MSearchParam
  ): Promise<MSearchResponse<T>> => {
    const response = await axiosInstance.post<MSearchResponse<T>>(
      M_SEARCH_API_URL,
      params
    );
    return response.data;
  },
};
